import { checkout_shippingAddress } from '@components/pages/CheckoutPage/__generated__/checkout';

export const isInvalidShippingAddress = (shippingAddress: checkout_shippingAddress) => {
  if (!shippingAddress) return true;

  if (!shippingAddress?.country || shippingAddress?.country?.code.trim() === '') {
    return true;
  }

  const requiredFields = [
    'city',
    'countryArea',
    'firstName',
    'lastName',
    'phone',
    'postalCode',
    'streetAddress1',
    'streetAddress2',
  ];

  for (const field of requiredFields) {
    const value = shippingAddress[field as keyof typeof shippingAddress];

    if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
      return true;
    }
  }

  return false;
};
